import { createNullableContext } from '~/common/contexts/nullableContext';
import { TenantedApplicationConfig } from './types/TenantedApplicationConfig';

export const TenantedApplicationConfigContext =
  createNullableContext<TenantedApplicationConfig>();
